export type RegisterStepHeadingProps = {
  title: string
  subtitle?: string
}

export function RegisterStepHeading({ title, subtitle }: RegisterStepHeadingProps) {
  return (
    <div className="flex flex-col gap-2.5">
      <h2 className="font-display text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
        {title}
      </h2>
      {subtitle ? (
        <p className="text-base text-muted-foreground sm:text-lg">{subtitle}</p>
      ) : null}
    </div>
  )
}
